<template>
  <div id="main_container">
    <div style="" id="image_title_container">
      <img
        src="https://cardiff.b-cdn.net/img/connect_plaid_title.svg"
        id="logo"
        height="180"
        width="352"
      />
      <div v-if="sfoppid">
        <div class="buttons button_container">
          <a
            class="
              button
              is-link
              padded-button
              next-button
              pure-button
              btn-success
            "
            @click="next"
            id="continue-journey-lead-bank-verification"
            >CONNECT WITH PLAID</a
          >
        </div>
      </div>
      <div v-else>
        <a :disabled="!sfoppid"
          class="disabled
            button
            is-link
            padded-button
            next-button
            pure-button
            btn-success
          "
          id="continue-journey-lead-bank-verification"
          >LOADING..</a
        >
      </div>
      <img
        src="https://cardiff.b-cdn.net/img/iphone_14_plaidv2.png"
        class="iphone_plaid_mobile"
        height="691"
        width="330px"
      />
      <br/>
      <p class="notes">
        *Cardiff can fund same day for applications approved by 5:00 p.m.
        Eastern Time on bank business days.
      </p>
    </div>
    <div id="image_container_desktop">
      <img
        src="https://cardiff.b-cdn.net/img/iphone_14_plaidv2.png"
        class="iphone_plaid_desktop"
        height="691"
        width="330px"
      />
    </div>
  </div>
</template>

<script>
function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "RenewalApplyVerification",
  components: {},
  props: {
    sfoppid: String,
    message: String
    },
  data() {
    return {
      inputs: {
        bvstarted: true,
      },
      obj: "financials",
      custom_message: "",
    };
  },
  mounted: function () {
    var animation = lottie.loadAnimation({
      container: document.getElementById("shield"), // the dom element that will contain the animation
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "../animations/Shield2.json", // the path to the animation json
    });
    this.custom_message = this.message;
    let first_name = getWithExpiry("first_name");
    if (first_name && first_name != "") {
      let lowerFirstLetter = this.message[0].toLowerCase();
      this.message = this.message.substring(1);
      let new_message = lowerFirstLetter + "" + this.message;
      this.custom_message = "Hey <b>" + first_name + "</b>, " + new_message;
    }
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* tablet */
.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: flex;
  /* mobile */
  background: url("https://cardiff.b-cdn.net/img/gradient-desktop.png");
  background-repeat: no-repeat;
  background-size: contain;
  /* /* height: 390px; */
  height: 80vh;
}
#image_title_container {
  /* mobile */

  background-size: contain;
  max-height: 650px;
  margin-left: 5%;
  /* background: transparent linear-gradient(52deg, #ffffff 0%, #d4dbec 100%) 0% 0%
    no-repeat padding-box;
  opacity: 1; */
  margin-top: 12px;
}
#image_container_desktop {
  margin-top: 48px;
}
#logo {
  padding-top: 64px;
  margin-bottom: 21px;
  width: 763px;
  /* height: 397px; */
}
#iphone_plaid {
  margin-bottom: 32px;
}
/* .button_container {
  margin-left: 3%;
} */
.notes {
  text-align: left;
  font-family: Roboto;
  font-size: 16px;
  margin-right: 8%;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 48px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
/* #app-column {
  padding-top: 0 !important;
} */
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  .btn-success {
    margin: 0 auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;

    max-height: none;
    background: url("https://cardiff.b-cdn.net/img/gradient-mobile.png");
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }

  .notes {
    /* margin-left: 32px; */
    margin-left: 8%;
  }
  #main_container {
    display: block;
    height: auto;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
    margin-top: 32px;
    margin-bottom: 32px;
  }
  #logo {
    padding-top: 48px;
    width: 90%;
  }
}
</style>
<style>
#app-column-lead {
  padding: 0 !important;
}
.container.is-fluid {
  margin-left: 0;
  margin-right: 0;
}
</style>